<template>
  <form-group :validator="v" :label="$t('state')">
    <input
      type="text"
      class="input"
      v-model="stateName"
      :placeholder="$t('AddState')"
      @input="v.$touch()"
    />
  </form-group>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    v: {
      type: Object,
      required: true
    }
  },
  computed: {
    stateName: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
